/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AccessTokenModalWarningTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ACCESS_TOKEN_MODAL_WARNING_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class AccessTokenModalWarningTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AccessTokenModalWarningTimeSettingParser.decode(input).map(res => new AccessTokenModalWarningTimeSetting(res));
    }
    static unsafeDecode(input) {
        return AccessTokenModalWarningTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessTokenModalWarningTimeSettingParser.encode(data);
    }
    static schema() {
        return AccessTokenModalWarningTimeSettingParser.schema();
    }
}
